angular.module('controllers').controller('streetController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog',
	function ($scope, $rootScope, $controller, Crud, $mdDialog) {
		$rootScope.path = '/street';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'street';
		$scope.pathTemplate = 'distribution/streets';
		$scope.title = 'Strazi';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'street_name';
		$scope.defaultItem = 10;
    $rootScope.typeId = 'id';
		$scope.classAction = 'td-big';
		$scope.columns = {
			'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'county_name':{'label':'Judet', 'filter':1, 'filterType':'input'},
			'locality_name':{'label':'Localitate', 'filter':1, 'filterType':'input'},
			'section_name':{'label':'Cartier', 'filter':1, 'filterType':'input'},
			'street_name':{'label':'Nume strada', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];
		$scope.search.order = 'asc';
		$scope.additionals['content_type'] = 'form-urlencoded';
		$scope.additionals['jsonPath'] = '/json';
        $scope.additionals['columnDisplay'] = 'street_name';

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
			$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

		$scope.additionals['getCounties'] = function () {
			Crud.get($scope.additionals['jsonPath'] + '/counties.json')
				.success(function (data) {
					$scope.additionals['counties'] = data;
				});
		}
		$scope.additionals['getCounties']();

		/* autocomplete */
		function createFilterForLocality(query) {
			var capitalizeQuery = $scope.formatText(query);
			return function filterFn(item) {
				return item.locality_name.indexOf(capitalizeQuery) >= 0;
			};
		}
        function createFilterForSection(query) {
            var capitalizeQuery = $scope.formatText(query);
            return function filterFn(item) {
                return item.section_name.indexOf(capitalizeQuery) >= 0;
            };
        }
        $scope.additionals['getLocalities'] = function(model, index) {
          if (angular.isUndefined(model.county_name)) {
                     model.county_name = 'Cluj';
          }
            model.locality_id = 0;
            Crud.get($scope.path + '/getLocalities?county_name='+model.county_name)
                .success(function (dataLoc) {

                    if(dataLoc.localities.length <= 0) {

                        Crud.get($scope.additionals['jsonPath'] + '/localities.json')
                            .success(function (data) {

                                if (angular.isUndefined(model.county_name)) {
                                    $scope.additionals['getLocalities']({"county_name": "Cluj"});
                                } else {
                                    if (!angular.isUndefined(index)) {
                                        $scope.additionals['localities' + index] = data[model.county_name];
                                    } else {
                                        $scope.additionals['localities'] = data[model.county_name];
                                    }
                                }
                                /* autocomplete */
                                function querySearch(query) {
                                    if (!angular.isUndefined(index)) {
                                        var results = query ? $scope.additionals['localities' + index].filter(createFilterForLocality(query)) : [];
                                    } else {
                                        if (!angular.isUndefined($scope.additionals['localities'])) {
                                            var results = query ? $scope.additionals['localities'].filter(createFilterForLocality(query)) : [];
                                        }
                                    }
                                    return results;
                                }
                                $scope.additionals['searchLocality'] = querySearch;
                                $scope.additionals['errors'] = {};
                                /* end autocomplete */

                            });
                    } else {

                        if (angular.isUndefined(model.county_name)) {
                            $scope.additionals['getLocalities']({"county_name": "Cluj"});
                        } else {
                            if (!angular.isUndefined(index)) {
                                $scope.additionals['localities' + index] = dataLoc['localities'];
                            } else {
                                $scope.additionals['localities'] = dataLoc['localities'];
                            }
                        }
                        /* autocomplete */
                        function querySearch(query) {
                            if (!angular.isUndefined(index)) {
                                var results = query ? $scope.additionals['localities' + index].filter(createFilterForLocality(query)) : [];
                            } else {
                                if (!angular.isUndefined($scope.additionals['localities'])) {
                                    var results = query ? $scope.additionals['localities'].filter(createFilterForLocality(query)) : [];
                                }
                            }
                            return results;
                        }
                        $scope.additionals['searchLocality'] = querySearch;
                        $scope.additionals['errors'] = {};
                        /* end autocomplete */
                    }

                });
        }
        $scope.additionals['getSections'] = function(model, index) {
            Crud.get($scope.path + '/getSections?county_name='+model.county_name+'&locality_name='+model.locality_name)
                .success(function (data) {
                    if (!angular.isUndefined(index)) {
                        $scope.additionals['sections' + index] = data['sections'];
                    } else {
                        $scope.additionals['sections'] = data['sections'];
                    }
                    /* autocomplete */
                    function querySearch(query) {
                        if (!angular.isUndefined(index)) {
                            var results = query ? $scope.additionals['sections' + index].filter(createFilterForSection(query)) : [];
                        } else {
                            if (!angular.isUndefined($scope.additionals['sections'])) {
                                var results = query ? $scope.additionals['sections'].filter(createFilterForSection(query)) : [];
                            }
                        }
                        return results;
                    }
                    $scope.additionals['searchSection'] = querySearch;
                    $scope.additionals['errors'] = {};
                    /* end autocomplete */
                });
        }
		/* end autocomplete */

		if (angular.isUndefined($scope.search.county_name)) {
			$scope.search.county_name = 'Cluj';
		}

		$scope.additionals['function']= function(ev, model) {
			$scope.additionals['selectedItemLocality'] = '';
                        $scope.additionals['selectedItemSection'] = '';

			if (angular.isUndefined(model.county_name)) {
				$scope.additionals['getLocalities']({"county_name":"Cluj"});
			}
			if($scope.action == 'store') {
				if (angular.isUndefined(model.county_name)) {
					model.county_name = 'Cluj';
				}
			}

			if($scope.action == 'update') {
				$scope.additionals['getLocalities'](model);
                $scope.additionals['getSections'](model);
				//$scope.additionals['selectedItemLocality'] = model.county_name;
			}
			if($scope.action == 'updatemultiple') {
				$scope.additionals['selectedItemLocality'] = [];
                $scope.additionals['selectedItemSection'] = [];
				angular.forEach(model, function (item, index) {
					$scope.additionals['getLocalities'](item, index);
                    $scope.additionals['getSections'](item, index);
				});
			}
		}

        $scope.additionals['internFunction'] = function(ev, model) {
            if($scope.action == 'updatemultiple') {
                angular.forEach(model, function (item, index) {
                    if(index != 'route') {
                        if (!angular.isUndefined($scope.additionals['localities'+index])) {
                            if (!angular.isUndefined($scope.additionals['localities' + index][0]['id'])) {
                                var checkLocalityId = $scope.additionals['checkField']($scope.additionals['localities' + index], 'id', 'locality_name', item['locality_name']);
                                if (checkLocalityId) {
                                    item.locality_id = checkLocalityId;
                                } else {
                                    item.locality_id = 0;
                                }
                            } else {
                                item.locality_id = 'js';
                            }
                        }
                        var checkLocalityName = $scope.additionals['checkField']($scope.additionals['localities'+index], 'locality_name', 'locality_name', item['locality_name']);
                        if (checkLocalityName) {
                            item.locality_name = checkLocalityName;
                        } else {
                            if(item.locality_id == 'js') {
                                item.locality_name = '';
                            }
                        }
                        if (!angular.isUndefined($scope.additionals['sections'+index])) {
                            var checkSectionId = $scope.additionals['checkField']($scope.additionals['sections' + index], 'id', 'section_name', item['section_name']);
                            if (checkSectionId) {
                                item.section_id = checkSectionId;
                            } else {
                                item.section_id = 0;
                            }
                        }
                        var checkSectionName = $scope.additionals['checkField']($scope.additionals['sections'+index], 'section_name', 'section_name', item['section_name']);
                        if (checkSectionName) {
                            item.section_name = checkSectionName;
                        }
                    }
                });
            } else {
                if (model['locality_name'] != '' && $scope.additionals['localities']) {
                    if (!angular.isUndefined($scope.additionals['localities'][0]['id'])) {
                        var checkLocalityId = $scope.additionals['checkField']($scope.additionals['localities'], 'id', 'locality_name', model['locality_name']);
                        if (checkLocalityId) {
                            model.locality_id = checkLocalityId;
                        } else {
                            model.locality_id = 0;
                        }
                    } else {
                        model.locality_id = 'js';
                    }

                    var checkLocalityName = $scope.additionals['checkField']($scope.additionals['localities'], 'locality_name', 'locality_name', model['locality_name']);
                    if (checkLocalityName) {
                        model.locality_name = checkLocalityName;
                    } else {
                        if(model.locality_id == 'js') {
                            model.locality_name = '';
                        }
                    }

                }
                if (model['section_name'] != '' && $scope.additionals['sections']) {
                    var checkSectionId = $scope.additionals['checkField']($scope.additionals['sections'], 'id', 'section_name', model['section_name']);
                    if (checkSectionId) {
                        model.section_id = checkSectionId;
                    } else {
                        model.section_id = 0;
                    }
                    var checkSectionName = $scope.additionals['checkField']($scope.additionals['sections'], 'section_name', 'section_name', model['section_name']);
                    if (checkSectionName) {
                        model.section_name = checkSectionName;
                    }
                } else {
                    model.section_id = 0;
                }
            }
        }

		$scope.additionals['functionResult']= function(ev, data) {
			if($scope.action == 'update' || $scope.action == 'store') {
				if (!angular.isUndefined($scope.modelData.street_name)) {
					$scope.modelData.street_name = $scope.additionals['formatTextResult']($scope.modelData.street_name);
				}
                if (!angular.isUndefined($scope.modelData.locality_name)) {
                    $scope.modelData.locality_name = $scope.additionals['formatTextResult']($scope.modelData.locality_name);
                }
                if (!angular.isUndefined($scope.modelData.section_name)) {
                    $scope.modelData.section_name = $scope.additionals['formatTextResult']($scope.modelData.section_name);
                }
			}
			if($scope.action == 'updatemultiple') {
				if (!angular.isUndefined($scope.modelsData)) {
					angular.forEach($scope.modelsData, function (item, key) {
						if (item.selected !== false) {
							if (!angular.isUndefined($scope.modelsData[key].street_name)) {
								$scope.modelsData[key].street_name = $scope.additionals['formatTextResult']($scope.modelsData[key].street_name);
							}
                            if (!angular.isUndefined($scope.modelsData[key].section_name)) {
                                $scope.modelsData[key].section_name = $scope.additionals['formatTextResult']($scope.modelsData[key].section_name);
                            }
                            if (!angular.isUndefined($scope.modelsData[key].locality_name)) {
                                $scope.modelsData[key].locality_name = $scope.additionals['formatTextResult']($scope.modelsData[key].locality_name);
                            }
						}
					});
				}

			}
		}

        /* change field */
        $scope.additionals['changeField']= function(model, prop, key) {
            if(prop == 'locality') {
                if (!angular.isUndefined(key)) {
                    model[key].locality_new = false;
                } else {
                    model.locality_new = false;
                }
            }
            if(prop == 'section') {
                if (!angular.isUndefined(key)) {
                    model[key].section_new = false;
                } else {
                    model.section_new = false;
                }
            }
        }

        /* close field */
        $scope.additionals['closeField'] = function (paramName, model, key) {

            if (!angular.isUndefined(key)) {
                model[key][paramName] = '';

                if (paramName == 'county_name') {
                    $scope.additionals['removeFields']('county', model, key);
                }
                if (paramName == 'locality_name') {
                    $scope.additionals['removeFields']('locality', model, key);
                }
                if (paramName == 'section_name') {
                    $scope.additionals['removeFields']('section', model, key);
                }

            } else {
                model[paramName] = '';

                if (paramName == 'county_name') {
                    $scope.additionals['removeFields']('county', model);
                }
                if (paramName == 'locality_name') {
                    $scope.additionals['removeFields']('locality', model);
                }
                if (paramName == 'section_name') {
                    $scope.additionals['removeFields']('section', model);
                }
            }

        }

        /* remove field */
        $scope.additionals['removeFields'] = function (field, modelData, key) {
            if (!angular.isUndefined(key)) {
                switch (field) {
                    case 'county':
                        modelData[key].locality_name='';
                        modelData[key].section_name = '';
                        modelData[key].street_name = '';
                        break;

                    case 'locality':
                        modelData[key].section_name = '';
                        modelData[key].street_name = '';

                        break;

                    case 'section':
                        //modelData[key].street_name = '';
                        break;
                }
            } else {
                switch (field) {
                    case 'county':
                        modelData.locality_name = '';
                        modelData.section_name = '';
                        modelData.street_name = '';
                        break;

                    case 'locality':
                        modelData.section_name = '';
                        modelData.street_name = '';

                        break;

                    case 'section':
                        //modelData.street_name = '';

                        break;

                }
            }
        }

        /* replace street */
        $scope.additionals['streets'] = [];
        $scope.additionals['getStreets'] = function (locality_name, street_name) {

                    $scope.additionals['errors'] = {};
                    if (!angular.isUndefined($scope.errors)) {
                        $scope.errors['street_id'] = {};
                    }
                if ( !angular.isUndefined(locality_name) && !angular.isUndefined(street_name) && street_name.length >= 2) {
                    return Crud.get($scope.path + '/getStreets?locality_name=' + locality_name + '&street_name=' + street_name)
                            .then(function (data) {
                                $scope.additionals['streets'] = data.data.streets;

                                return data.data.streets;
                            });
                } else {
                    return [];
                }

        }

        $scope.replaceStreetModel = function (ev, path) {
                    $scope.actionLabel = 'Inlocuire strada';
                    $scope.additionals['selectedItemLocalityFrom'] = '';
                    $scope.additionals['selectedItemLocalityTo'] = '';
                    $scope.additionals['selectedItemStreetFrom'] = '';
                    $scope.additionals['selectedItemStreetTo'] = '';

                    if (angular.isUndefined($scope.modelDataReplace)) {
                        $scope.modelDataReplace = {};
                    }
                    if ($scope.mode_action == 'page') {
                        $scope.controlSH = true;
                        $scope.action = 'replacestreet';
                        $scope.errors = {};
                        $scope.additionals['invalid'] = '';

                        $scope.cancel = function () {
                            $scope.modelDataReplace = {};
                            $scope.errors = {};
                            $scope.controlSH = false;
                        };

                $scope.replaceStreet = function () {

                            $scope.additionals['buttonDisabled'] = true;
                            $scope.isLoading = true;
                            var post = {};
                            post['route'] =  'replaceStreet';
                            post['locality_name_from'] =  $scope.modelDataReplace['locality_name_from'];
                            post['street_name_from'] =  $scope.modelDataReplace['street_name_from'];
                            post['locality_name_to'] =  $scope.modelDataReplace['locality_name_to'];
                            post['street_name_to'] =  $scope.modelDataReplace['street_name_to'];
                            post['delete_from'] =  $scope.modelDataReplace['delete_from'];

                         Crud.post('form-urlencoded', post, path + '/replaceStreet')
                                    .success(function (data) {
                                        if (!angular.isUndefined(data.invalid)) {
                                            $scope.additionals['invalid'] = data.invalid;
                                        }
                                        $scope.modelDataReplace = {};
                                        $scope.errors = {};
                                        $scope.isLoading = false;
                                        $scope.additionals['buttonDisabled'] = false;
                                        $scope.success = true;
                                    })
                                    .error(function (data) {
                                        $scope.isLoading = false;
                                        $scope.errors = data.errors;
                                        $scope.additionals['buttonDisabled'] = false;
                                        if (data == null) {
                                            $rootScope.checkNetworkConnection();
                                        }
                                    });
                        };
                    }
                    if ($scope.mode_action == 'dialog') {

                        $scope.additionals['invalid'] = '';
                        $scope.errors = {};
                        $scope.action = 'replaceStreet';

                        $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'replaceStreetDialog.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: {
                                pathTemplate: $scope.pathTemplate,
                                model: $scope.modelDataReplace,
                                additionals: $scope.additionals,
                            }
                        }).then(function () {

                        });
                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model',  'additionals'];
                        function DialogController($scope, $mdDialog, pathTemplate, model, additionals) {
                            $scope.pathTemplate = pathTemplate;
                            $scope.modelDataReplace = model;
                            $scope.additionals = additionals;

                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };

                            $scope.replaceStreet = function () {
                                $scope.additionals['buttonDisabled'] = true;
                                $scope.isLoading = true;

                                var post = {};
                                    post['route'] =  'replaceStreet';
                                    post['locality_name_from'] =  $scope.modelDataReplace['locality_name_from'];
                                    post['street_name_from'] =  $scope.modelDataReplace['street_name_from'];
                                    post['locality_name_to'] =  $scope.modelDataReplace['locality_name_to'];
                                    post['street_name_to'] =  $scope.modelDataReplace['street_name_to'];
                                    post['delete_from'] =  $scope.modelDataReplace['delete_from'];

                                 Crud.post('form-urlencoded', post, path + '/replaceStreet')
                                        .success(function (data) {
                                            if (!angular.isUndefined(data.invalid)) {
                                                $scope.additionals['invalid'] = data.invalid;
                                            }
                                            $scope.modelDataReplace = {};
                                            $scope.isLoading = false;
                                            $scope.additionals['buttonDisabled'] = false;
                                            $scope.success = true;
                                        })
                                        .error(function (data) {
                                            $scope.isLoading = false;
                                            $scope.errors = data.errors;
                                            $scope.additionals['buttonDisabled'] = false;
                                            if (data == null) {
                                                $rootScope.checkNetworkConnection();
                                            }
                                        });
                            };

                        }
                    }
                };

         /* end replace street */

	}]
);
